import { render } from "./CareersForm.vue?vue&type=template&id=2d0b5bfc&scoped=true"
import script from "./CareersForm.vue?vue&type=script&lang=js"
export * from "./CareersForm.vue?vue&type=script&lang=js"

import "./CareersForm.vue?vue&type=style&index=0&id=2d0b5bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0b5bfc"]])

export default __exports__